import axios from 'axios';
import {updateToken} from "@entities/Authentication/model/slice/authenticationSlice";

export const $api = axios.create({
    baseURL: process.env.REACT_APP_DJANGO_API ?? 'https://api.gonget.net'
});


let isRefreshing = false;
let failedRequestsQueue: any[] = [];

export const configureInterceptors = (store: any) => {
    const instances = [$api];

    instances.forEach((axios) => {
        axios.interceptors.request.use((config) => {
            try {
                // @ts-ignore
                const accessToken = store.getState()?.authenticationReducer?.accessToken;

                if (Boolean(accessToken)) {
                    config.headers['Authorization'] = `${accessToken}`;
                }
                config.headers['Access-Control-Allow-Origin'] = '*';
                config.headers["Access-Control-Allow-Methods"] = "GET, POST, PUT, DELETE, OPTIONS, HEAD";
                config.headers["Access-Control-Allow-Headers"] = "Access-Control-Allow-Headers, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Authorization, Content-Type";


            } catch (error) {
                console.log(error);
            }

            return config;
        })
    })
    instances.forEach((axiosInstance) => {
      axiosInstance.interceptors.response.use(
            response => response,
            async error => {

              const originalRequest = error.config;

              if (error.response?.status === 401 && !originalRequest._retry) {
                if (isRefreshing) {
                  return new Promise((resolve) => {
                    failedRequestsQueue.push((token: any) => {
                      originalRequest.headers["Authorization"] = `${token}`;
                      resolve(axiosInstance(originalRequest));
                    });
                  });
                }

                originalRequest._retry = true;
                isRefreshing = true;

                try {

                  const refreshToken = store.getState()?.authenticationReducer?.refreshToken

                  if (!refreshToken) {
                    throw new Error("No refresh token available");
                  }

                  const { data } = await $api.post('/api/refresh/', {
                    "refresh_token": refreshToken,
                  });

                  store.dispatch(updateToken(data))

                  axiosInstance.defaults.headers["Authorization"] = `Bearer ${data.accessToken}`;

                  failedRequestsQueue.forEach((callback) => callback(data.accessToken));
                  failedRequestsQueue = [];

                  return axiosInstance(originalRequest);
                } catch (refreshError) {
                  // failedRequestsQueue = [];
                  // console.error('Token refresh failed:', refreshError);
                  // store.dispatch({ type: "RESET" })
                  // window.location.href = '/main';
                  // return Promise.reject(refreshError);
                } finally {
                  isRefreshing = false;
                }

              }

            },
        );
    })
}
